module.exports = __webpack_public_path__ + "static/media/ErrorsAndWarnings.5369462a.png";